import { lectio } from '../api';
import ActionTypes from '../constants/ActionTypes';
import { isLatestArticlesLoaded } from '../selectors/latest-articles';

export const fetchLatestArticles = () => {
  return async (dispatch, getState) => {
    if (isLatestArticlesLoaded(getState())) return;
    try {
      const { data: latestArticles } = await lectio.get(`/articles/latest`);
      return dispatch({
        type: ActionTypes.FETCH_LATEST_ARTICLES_SUCCESS,
        payload: latestArticles
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return dispatch({
          type: ActionTypes.FETCH_LATEST_ARTICLES_NOT_FOUND
        });
      }
      return dispatch({
        type: ActionTypes.FETCH_LATEST_ARTICLES_ERROR
      });
    }
  };
};
